import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { getFile, getFileMediaId, getMediaFromUrl } from '../store/actions/globalAction';

function TemplateImagePreview({ url, className, mediaId, waba, link, errorIcon }) {
    let dispatch = useDispatch();
    const [previewfile, setPreviewfile] = useState();

    useEffect(() => {
        if (link && link != "") {
            if (!link?.startsWith("http")) {
                link = `${process.env.REACT_APP_PRODUCT_APIURL}/storage/media/file?kay=${link}`;
            }
            getMediaFromUrl(link).then(ul => { setPreviewfile(ul) });
        }
        else if (mediaId && mediaId != "") {
            getFileMediaId(waba?.tenantId, waba?.id, mediaId).then(md => { setPreviewfile(md) });
        }
        else if (url && url != "") {
            getFile(url).then(ul => { setPreviewfile(ul) });
        } else {
            setPreviewfile(null);
        }
    }, [url])

    return (
        <div className='h-[120px]'>
            {previewfile ?
                <img className={"h-full w-full object-contain rounded-md" + (className ?? "")} src={previewfile} onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = errorIcon ?? `${process.env.PUBLIC_URL}/images/folder_ico.png`;
                }} /> :
                <div className='flex justify-center pt-10'><i className="fa-solid fa-image text-[24px] text-gray-400"></i></div>}
        </div>
    )
}

export default TemplateImagePreview